/**
 * The legacy `name/line1/line2/city/state/zip` order address, one of the shapes
 * `orders.shipping_address` holds (`orderAddressCountry` lists them). Pure, so Edit Address's form
 * reads the same keys the server's save drops.
 */

/** Each legacy key by the form field it fills. `name` is split into first and last when read. */
export const LEGACY_ADDRESS_FIELD_KEYS = {
  addressLine1: "line1",
  addressLine2: "line2",
  locality: "city",
  region: "state",
  postalCode: "zip",
} as const;

/** The legacy shape's name key, first and last together. */
export const LEGACY_ADDRESS_NAME_KEY = "name";

/** Every legacy key, which a staff save drops so no reader falls back to the replaced address. */
export const LEGACY_ADDRESS_KEYS: readonly string[] = [
  LEGACY_ADDRESS_NAME_KEY,
  ...Object.values(LEGACY_ADDRESS_FIELD_KEYS),
];
